export const environment = {
    apiUrl: 'https://api-dev.legitid.org/dashboard/api/',
    // apiUrl: 'http://localhost:6107/api/',
    appUrl: '',
    oriURL: 'http://localhost:4200',
    contentPackage: 'https://api-dev.legitid.org/content/package/',
    contentOG: 'https://api-dev.legitid.org/content/organizations/',
};
